import apiCall from '../index'

const apiService = '/gsencuesta/api/v1/encuesta'
const apiServiceLogo = '/gsencuesta/api/v1/recurso'

const service = {
  findAll(params) {
    const query = `?limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const authorization = 'Authorization'
    const formData = new FormData()
    formData.append('idProyecto', model.proyecto.idProyecto)
    formData.append('titulo', model.titulo)
    formData.append('descripcion', model.descripcion)
    formData.append('urlGuia', model.urlGuia)
    formData.append('tipoVista', model.tipoVista)
    formData.append('expira', model.expira)
    formData.append('dinamico', model.dinamico)
    formData.append('fechaInicio', model.fechaInicio)
    formData.append('fechaFin', model.fechaFin)
    formData.append('publicado', model.publicado)
    formData.append('esRetomado', model.esRetomado)
    formData.append('sourceMultimedia', model.sourceMultimedia)
    formData.append('requeridoObservacion', model.requeridoObservacion)
    formData.append('encuestadoIngresoManual', model.encuestadoIngresoManual)
    formData.append('requeridoMultimedia', model.requeridoMultimedia)
    formData.append('meta', model.meta)
    formData.append('logo', model.logo)
    formData.append('orientacion', 'H')
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .post(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    const authorization = 'Authorization'
    const formData = new FormData()
    formData.append('idEncuesta', model.idEncuesta)
    formData.append('idProyecto', model.proyecto.idProyecto)
    formData.append('titulo', model.titulo)
    formData.append('descripcion', model.descripcion)
    formData.append('urlGuia', model.urlGuia)
    formData.append('tipoVista', model.tipoVista)
    formData.append('expira', model.expira)
    formData.append('dinamico', model.dinamico)
    formData.append('publicado', model.publicado)
    formData.append('fechaInicio', model.fechaInicio)
    formData.append('sourceMultimedia', model.sourceMultimedia)
    formData.append('requeridoObservacion', model.requeridoObservacion)
    formData.append('requeridoMultimedia', model.requeridoMultimedia)
    formData.append('encuestadoIngresoManual', model.encuestadoIngresoManual)
    formData.append('fechaFin', model.fechaFin)
    formData.append('meta', model.meta)
    formData.append('logo', model.logo)
    formData.append('esRetomado', model.esRetomado)
    formData.append('orientacion', 'H')
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  clone(params) {
    const query = `/clone?idProyecto=${params.idProyecto}&idEncuesta=${params.idEncuesta}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  /* update(model) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .put(apiService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  }, */
  findLogo(params) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiServiceLogo}/encuesta/${params.idEncuesta}`, {
          responseType: 'arraybuffer',
        })
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findByProyecto(params) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiService}/byProyecto/${params.idProyecto}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findFicha(params) {
    const query = `?idEncuesta=${params.idEncuesta}&fechaInicio=${params.fechaInicio}&fechaFinal=${params.fechaFinal}&idUsuario=${params.idUsuario}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(`${apiService}/findFicha${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
